<!--  -->
<template>
  <main>
    <Banner></Banner>

    <div class="container">
      <DisCordBanner />
      <classify />
      <!-- 游戏推荐 -->
      <div class="live-wrap">
        <div class="game-live-section">
          <div class="game-live">
            <div class="section-title-box">
              <h2 class="show-container-title">{{ $t('lang041') }}</h2>
              <div class="live-sort-list">
                <a
                  v-for="(game, index) in gameRecommendLabel"
                  :key="index"
                  :class="[
                    'live-sort-list__item',
                    { active: gameRecommendIndex === index }
                  ]"
                  href="javascript:;"
                  @click="fetchGameRecommendList(game.tabId, index)"
                >
                  {{ $t(game.title) }}
                </a>
              </div>
              <nuxt-link :to="localePath('/games')" class="classify__more-btn">
                <div>
                  {{ $t('lang040') }}
                </div>
                <div class="arrow-icon"></div>
              </nuxt-link>
            </div>
            <ul class="recommend-video-list">
              <game-room-entrance
                v-for="(room, index) in gameRecommendList"
                :key="index"
                :room-info="room"
              />
            </ul>
          </div>
        </div>
        <!-- 赛事模块，移除注释即可 -->
        <!-- <div class="live-right-section">
          <div class="section-title">{{ $t('lang043') }}</div>
          <div class="banner-pic">
            <swiper type="indexBanner" />
          </div>
        </div> -->
      </div>
      <!-- 主播推荐 -->
      <div class="live-wrap">
        <div class="live-section showbiz-live-section">
          <div class="showbiz-live">
            <div class="section-title-box">
              <h2 class="show-container-title">{{ $t('lang042') }}</h2>

              <country-classify
                :currentTabType="currentTabType"
                :inIndex="true"
                @on-change="fetchShowList"
              />
            </div>
            <ul class="recommend-video-list">
              <show-room-entrance
                v-for="(room, index) in showbizRecommendList"
                :key="index"
                :room-info="room"
              />
            </ul>
          </div>
        </div>
        <div class="live-right-section">
          <div class="section-title">{{ $t('lang044') }}</div>
          <top-rank
            :week-get-rank-list="weekGetRankList"
            :week-send-rank-list="weekSendRankList"
          />
        </div>
      </div>
    </div>
    <fix-tool />
  </main>
</template>

<script>
import { mapGetters } from 'vuex';
import Classify from '@components/Classify';
import DisCordBanner from '@components/DisCordBanner';
import TopRank from '@components/TopRank';
import GameRoomEntrance from '@components/GameRoomEntrance';
import ShowRoomEntrance from '@components/ShowRoomEntrance';
import CountryClassify from '@components/CountryClassify';
import Banner from '@components/Banner';
import FixTool from '@components/FixTool';
// import Swiper from '@components/Swiper';
import api from '@services';
import { getCountryCode } from '@assets/js/utils';

export default {
  scrollToTop: true,
  components: {
    Classify,
    Banner,
    TopRank,
    FixTool,
    GameRoomEntrance,
    ShowRoomEntrance,
    // Swiper,
    CountryClassify,
    DisCordBanner
  },
  data() {
    this.countryClassify = [
      {
        tabId: 'ALL',
        title: 'lang058'
      },
      {
        tabId: 'ID',
        title: 'lang060'
      },
      {
        tabId: 'IN',
        title: 'lang061'
      },
      {
        tabId: 'VN',
        title: 'lang062'
      },
      {
        tabId: 'TH',
        title: 'lang063'
      },
      {
        tabId: 'JP',
        title: 'lang081'
      },
      {
        tabId: 'US',
        title: 'lang076'
      },
      {
        tabId: 'IT',
        title: 'lang233'
      },
      {
        tabId: 'DE',
        title: 'lang226'
      }
    ];
    return {
      gameRecommendIndex: 0,
      gameRecommendList: [],
      showbizRecommendList: [],
      weekGetRankList: [],
      weekSendRankList: [],
      currentTabType: 'ALL'
    };
  },
  computed: {
    ...mapGetters(['gameRecommendLabel'])
  },
  async created() {
    if (process.client) {
      const res = await api.getGamingList({
        tabType: '00',
        fetchNum: 16,
        countryCode: getCountryCode(this.$i18n.locale, true),
        lang: this.$i18n.locale
      });
      const gameRecommendList = res ? res.data : [];
      this.gameRecommendList = gameRecommendList.slice(0, 10) || [];

      this.currentTabType = getCountryCode(this.$i18n.locale);

      const showRes = await api.getShowbizList({
        tabType: this.currentTabType,
        fetchNum: 16
      });
      const showbizRecommendList = showRes ? showRes.data : [];
      this.showbizRecommendList = showbizRecommendList.slice(0, 8) || [];

      const weekGetRankList = await api.getWeekGetRank();
      this.weekGetRankList = weekGetRankList?.slice(0, 20) || [];

      const weekSendRankList = await api.getWeekSendRank();
      this.weekSendRankList = weekSendRankList?.slice(0, 20) || [];

      this.$store.dispatch('getGameClassifyList');
    }
  },
  mounted() {
    if (window.assetsLoadMonitor) {
      window.assetsLoadMonitor.sendCustomKeyReport({
        type: 'first_screen_time', // 自定义打点类型， type参数不能是page_view_time 和 white_screen_time， 因为会和公共库pv和白屏打点冲突
        extra: {
          // 扩展信息， 业务按需传
          msg: '首屏时间',
          page: 'index/index'
        }
      });
    }

    this.checkIsJump();
  },
  methods: {
    // 如果这些官网发现没有被成功302到对应的官网，就js手动跳转
    checkIsJump() {
      const map = {
        'bigolive-jp.com': '/jp',
        'chat.bigo.tv': '/crushme',
        'stream.bigo-official.com': '/ad'
      };
      const { host } = window.location;
      if (map[host]) {
        this.$router.replace(this.localeRoute(map[host]));
      }
    },
    fetchGameRecommendList(tabType, index = 0) {
      this.gameRecommendIndex = index;
      this.$api
        .getGamingList({
          tabType,
          fetchNum: 16,
          countryCode: getCountryCode(this.$i18n.locale, true),
          lang: this.$i18n.locale
        })
        .then((res) => {
          const data = res ? res.data : [];
          if (data && data.length > 0) {
            this.gameRecommendList = data.slice(0, 10);
          }
        });
    },
    fetchShowList(tabType) {
      if (tabType) {
        this.currentTabType = tabType;
        this.showbizRecommendList = [];
      }
      this.$api
        .getShowbizList({
          tabType: this.currentTabType,
          fetchNum: 30
        })
        .then((res) => {
          const data = res?.data || [];
          if (data && data.length > 0) {
            this.showbizRecommendList = data.slice(0, 8);
          }
        });
    }
  }
};
</script>
<style lang="scss" scoped>
.container {
  width: 1340px;
  margin: 0 auto;
  padding-top: 60px;

  .show-container-title {
    font-size: 28px;
    font-weight: 600;
    color: #2f3033;
    line-height: 40px;
    margin-bottom: 8px;
  }
}

.live-wrap {
  overflow: hidden;
  margin-top: 15px;
  // border-top: 1px #eee solid;
}

.live-section {
  float: left;
  width: 1060px;
}

.recommend-video-list {
  position: relative;
  overflow: hidden;
  margin-right: -25px;
}

.live-right-section {
  float: right;
  width: 250px;
  padding-top: 93px;
  position: relative;
  left: -10px;

  .section-title {
    margin-right: 30px;
    margin-bottom: 25px;
    vertical-align: middle;
    font-size: 20px;
    font-weight: 600;
    color: #2f3033;
    line-height: 28px;
  }

  .banner-pic {
    height: 404px;
    overflow: hidden;
    position: relative;
    border-radius: 2px;
  }
}

.section-title-box {
  position: relative;
}

.classify__more-btn {
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 13px;
  font-weight: 400;
  color: #8a8f99;
  line-height: 16px;
  position: absolute;
  bottom: 9px;
  right: 8px;

  .arrow-icon {
    width: 12px;
    height: 12px;
    background-repeat: no-repeat;
    background-position: center center;
    background-size: cover;
    background-image: url('~@assets/img/right_arrow.png');
  }
}
</style>
